// Tameeni URLs
export const TameeniURL = "https://www.tameeni.com/";
export const TameeniFAQ = `${TameeniURL}ar/car/faq`;
export const TameeniFAQEN = `${TameeniURL}en/car/faq`;
export const TameeniSamaPolicies = `${TameeniURL}compliance-policy-center`;
export const TameeniSamaPoliciesEN = `${TameeniURL}en/compliance-policy-center`;
export const TameeniCareer = `${TameeniURL}ar/career`;
export const TameeniCareerEN = `${TameeniURL}en/career`;
export const TameeniPartners = `${TameeniURL}partners`;
export const TameeniPartnersEN = `${TameeniURL}en/partners`;
export const TameeniContactUsAR = `${TameeniURL}contact-us`;
export const TameeniContactUsEN = `${TameeniURL}en/contact-us`;

export const TameeniPrivacyPolicy = `${TameeniURL}privacy-policy`;
export const TameeniPrivacyPolicyEN = `${TameeniURL}en/privacy-policy`;
export const TameeniTerms = `${TameeniURL}terms-and-conditions`;
export const TameeniTermsEN = `${TameeniURL}en/terms-and-conditions`;
export const TameeniCustomerCareNumber = "tel:966920011021";
export const TameeniCustomerCareWhatsApp =
  "https://api.whatsapp.com/send?phone=9668002444455";

// Tameeni Social Media
export const TameeniGoogle = "https://g.co/kgs/mzYosC";
export const TameeniTwitter = "https://g.co/kgs/mzYosC";
export const TameeniInstagram = "https://www.instagram.com/tameeniksa";
export const TameeniFacebook = "https://g.co/kgs/mzYosC";
export const TameeniSnapchat = "https://www.snapchat.com/add/tameeniksa";
export const TameeniYoutube = "https://www.youtube.com/Tameeniksa";
export const TameeniWhatsapp =
  "https://api.whatsapp.com/send?phone=966920011021&text=&source=&data=&app_absent=";

// Application stores
export const TameeniGooglePlay =
  "https://play.google.com/store/apps/details?id=tameeni.com";
export const TameeniAppStore =
  "https://apps.apple.com/us/app/%D8%AA%D8%A3%D9%85%D9%8A%D9%86%D9%8A/id1501339487?ls=1";
export const TameeniAppGallery = "https://appgallery.huawei.com/app/C104656303";
